import { Component } from '@angular/core';

@Component({
  selector: 'app-sanjay-techno-products-pvt-ltd',
  templateUrl: './sanjay-techno-products-pvt-ltd.component.html',
  styleUrls: ['./sanjay-techno-products-pvt-ltd.component.scss']
})
export class SanjayTechnoProductsPvtLtdComponent {

}
